/* Packages */
import React from "react";
import { observer } from "mobx-react-lite";
import compareStore from "../store";

/* Components */
import { CompareIcon } from "../../common/Icons";

const CompareToggle = ({ vehicle, isVOP, compareItems }) => {

    const hasCompared = () => {
        return compareStore.hasItem(vehicle.id);
    }

    const toggleCompare = () => {
        if (compareStore.hasItem(vehicle.id)) {
            compareStore.removeItem(vehicle.id);
        } else {
            compareStore.addItem(vehicle);
        }
    }

    /* Render */
    return (
        <>
            {isVOP ? (
                <div className="custom-control custom-checkbox z-index-1">
                    <input
                        id={`compare-vehicle-${vehicle.id}-checkbox`}
                        className="custom-control-input"
                        type="checkbox"
                        checked={hasCompared()}
                        onChange={() => toggleCompare()}
                    />
                    <label htmlFor={`compare-vehicle-${vehicle.id}-checkbox`} className="custom-control-label">
                        {window.Translator.trans("app.comparing.vehicle_overview.compare_checkbox_title")}
                    </label>
                </div>
            ) : (
                <button
                    className={`btn btn-link btn--rounded mr-2 btn--compare ${hasCompared() ? 'has-compared' : ''}`}
                    data-web-interaction-text="compare"
                    data-web-interaction-location="vehicle_detail_page"
                    aria-label="Compare"
                    onClick={() => toggleCompare()}
                >
                    <CompareIcon className="icon icon--24 icon--compare" />
                </button>
            )}
        </>
    );
}

const ObservingCompareToggleItems = observer((props) => {
    return (
        <CompareToggle
            {...props}
            compareItems={compareStore.compareItems}
        />
    );
});

export { CompareToggle, ObservingCompareToggleItems };
